export default "__VITE_ASSET__kEv_7VA$kqF3ey15VrrTtQ__";